import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'broker-h',
  templateUrl: './broker-h.component.html',
  styleUrls: ['./broker-h.component.css'],
})

export class BrokerSelectionHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Broker Selection Rule Event Log");

    $(document).ready(function() {
  			// prepare the data
  			var data = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Default",
  				"counterparty" : "JPM",
  				"limit" : "100M",
  				"ccy" : "USD"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"counterparty" : "JPM",
  				"limit" : "200M",
  				"ccy" : "USD"
  			}, {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"counterparty" : "CS",
  				"limit" : "50M",
  				"ccy" : "JPY"
  			} ];

  			// initialize jqxGrid
  			var source = {
  				localdata : data,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				}, {
  					name : 'counterparty',
  					type : 'string'
  				}, {
  					name : 'limit',
  					type : 'string'
  				}, {
  					name : 'ccy',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#counterpartyCreditLimitGrid", source);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '120'
  			}, {
  				text : 'Counterparty',
  				columntype : 'textbox',
  				datafield : 'counterparty',
  				width : '100'
  			}, {
  				text : 'Limit',
  				columntype : 'textbox',
  				datafield : 'limit',
  				width : '100'
  			}, {
  				text : 'Ccy',
  				columntype : 'textbox',
  				datafield : 'ccy',
  				width : '50'
  			} ];
  			$("#counterpartyCreditLimitGrid").jqxGrid(settings);

  			// Counterpart Exposure Limits

  			// prepare the data
  			var data = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Default",
  				"counterparty" : "JPM",
  				"limit" : "100M",
  				"ccy" : "USD"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"counterparty" : "JPM",
  				"limit" : "200M",
  				"ccy" : "USD"
  			}, {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C",
  				"counterparty" : "CS",
  				"limit" : "50M",
  				"ccy" : "JPY"
  			} ];

  			// initialize jqxGrid
  			var source = {
  				localdata : data,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				}, {
  					name : 'counterparty',
  					type : 'string'
  				}, {
  					name : 'limit',
  					type : 'string'
  				}, {
  					name : 'ccy',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#counterpartyExposureLimitGrid", source);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '120'
  			}, {
  				text : 'Counterparty',
  				columntype : 'textbox',
  				datafield : 'counterparty',
  				width : '100'
  			}, {
  				text : 'Limit',
  				columntype : 'textbox',
  				datafield : 'limit',
  				width : '100'
  			}, {
  				text : 'Ccy',
  				columntype : 'textbox',
  				datafield : 'ccy',
  				width : '50'
  			} ];
  			$("#counterpartyExposureLimitGrid").jqxGrid(settings);

  			// Account Netting Restrictions

  			// prepare the data
  			var data2 = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account C"
  			} ];

  			// initialize jqxGrid
  			var source2 = {
  				localdata : data2,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#accountNettingGrid", source2);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '100'
  			} ];
  			$("#accountNettingGrid").jqxGrid(settings);

  		});

  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/broker-h/broker-h.component.ts